module.exports = __webpack_public_path__ + "img/03_noff_close_L1.42abd8fb.svg";